import { render } from "./Disputes.vue?vue&type=template&id=1a47352e&ts=true"
import script from "./Disputes.vue?vue&type=script&lang=ts"
export * from "./Disputes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__